import {
  Carousel,
  CarouselContent,
  CarouselNext,
  CarouselPrevious,
} from "@components/ui/Carousel";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

import ProductListHeader from "./ProductListHeader";

type ProductListCarouselProps = ComponentPropsWithoutRef<"section"> & {
  title?: ReactNode;
  link?: ReactNode;
};

const ProductListCarousel = ({
  children,
  className,
  title,
  link,
}: ProductListCarouselProps) => {
  return (
    <section className={className}>
      <ProductListHeader>
        <h2 className="uppercase">{title}</h2>
        {link}
      </ProductListHeader>
      <Carousel
        opts={{
          align: "start",
          slidesToScroll: "auto",
        }}
      >
        <CarouselContent>{children}</CarouselContent>
        <CarouselPrevious className="left-3 -translate-y-16 bg-white hover:opacity-75" />
        <CarouselNext className="right-3 -translate-y-16 bg-white hover:opacity-75" />
      </Carousel>
    </section>
  );
};

ProductListCarousel.displayName = "ProductListCarousel";

export default ProductListCarousel;
